import { RecommendedAction } from 'api/types/shared.types';
import algoliaSearch from 'utils/algoliaSearch';
import getSearchConfig from 'utils/search/getSearchConfig';
import getSearchLocationOptions from 'utils/search/getSearchLocationOptions';
import { getVolopsSearchIndex } from 'utils/search/getVolopsSearchIndex';

export async function getRecommendedActions(
  searchLocation: Pick<SearchLocation, 'latitude' | 'longitude'>,
  queryOptions?: QueryOptions
) {
  const searchConfig = getSearchConfig();
  let locationOptions = {};

  if (searchLocation && searchLocation.latitude && searchLocation.longitude) {
    locationOptions = getSearchLocationOptions(
      'auto',
      searchLocation
    ).locationOptions;
  }

  const options: QueryOptions = {
    index: getVolopsSearchIndex(),
    filters: 'type:VOLOP AND source:IDEALIST',
    hitsPerPage: 20,
    attributesToRetrieve: [
      'objectID',
      'name',
      'city',
      'state',
      'logo',
      'orgName',
      'url',
    ],
    ...locationOptions,
    ...queryOptions,
  };
  return algoliaSearch<RecommendedAction>(searchConfig, '', options).then(
    ({ hits }) => hits
  );
}
